import { createContext } from 'react';

export function getStoreContext<T>(store: T) {
  const Context = createContext(store);
  const Provider = (props: { children: React.ReactNode }) => {
    return <Context.Provider value={store}>{props.children}</Context.Provider>;
  };
  return { Provider, Context };
}
